import { useEffect, useMemo, useState } from 'react';
import { api } from '../lib/api';
import { formatCLP } from '../lib/format';
import type { CustomerSummary } from '../types';

export function CustomersPanel({ advanced }: { advanced: boolean }) {
  const [customers, setCustomers] = useState<CustomerSummary[]>([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.admin.customers().then((list) => {
      setCustomers(list);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    const lower = search.toLowerCase().trim();
    if (!lower) return customers;
    return customers.filter((c) =>
      c.email.toLowerCase().includes(lower) ||
      c.name.toLowerCase().includes(lower) ||
      c.phone.toLowerCase().includes(lower)
    );
  }, [customers, search]);

  return (
    <section className="admin-card">
      <div className="admin-card-head">
        <div>
          <h2>Clientes</h2>
          <p className="muted">Lista agregada de quienes han hecho pedidos. Útil para campañas o atención post-venta.</p>
        </div>
        <div className="header-actions-row">
          {advanced && (
            <button type="button" className="ghost-button compact" onClick={() => api.admin.exportCustomers()}>
              Exportar CSV
            </button>
          )}
        </div>
      </div>

      <input
        type="search"
        placeholder="Buscar por email, nombre o teléfono"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginTop: 12, marginBottom: 16 }}
      />

      {loading ? (
        <p className="muted">Cargando clientes...</p>
      ) : filtered.length === 0 ? (
        <div className="empty-state subtle">
          <p>No hay clientes para mostrar.</p>
          <p className="muted">Aparecen automáticamente cuando entran pedidos.</p>
        </div>
      ) : (
        <div className="customers-table">
          <div className="customers-row customers-head">
            <span>Cliente</span>
            <span>Contacto</span>
            <span>Pedidos</span>
            <span>Total comprado</span>
            <span>Último pedido</span>
          </div>
          {filtered.map((c) => (
            <div className="customers-row" key={c.email}>
              <div>
                <strong>{c.name || '(sin nombre)'}</strong>
                <small>{c.email}</small>
              </div>
              <div>
                <span>{c.phone || '—'}</span>
              </div>
              <div><strong>{c.ordersCount}</strong></div>
              <div><strong>{formatCLP(c.totalSpent)}</strong></div>
              <div>
                <span>#{c.lastOrderNumber}</span>
                <small>{c.lastOrderAt ? new Date(c.lastOrderAt).toLocaleDateString('es-CL') : '—'}</small>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
